module.exports = __webpack_public_path__ + "img/culture_06.d7d4866f.png";